export const AI_CREDIT_EVENT = "chatpilots:ai-credit-exhausted";
export const AI_CREDIT_EXHAUSTED_CODE = "ai_credits_exhausted";
export const AI_CREDIT_EXHAUSTED_MESSAGE = "AI kullanim krediniz yetersiz";
export const AI_CREDIT_ALERT_MESSAGE =
  "AI kullanim krediniz yetersiz. Yeni AI islemleri durduruldu. Plan sayfasindan kredi ekleyebilirsiniz.";
const LEGACY_LIMIT_MESSAGES = [
  "aylik mesaj limitiniz doldu",
  "mesaj limitinizi",
  "trial suresi bitti",
];

function normalizeText(value) {
  return String(value || "").trim().toLowerCase();
}

export function getAiCreditErrorPayload(errorLike, overrides = {}) {
  const response = errorLike && errorLike.response ? errorLike.response : null;
  const data = response && response.data ? response.data : {};
  const code = String(
    overrides.code ||
      data.code ||
      data.error_code ||
      ""
  ).trim();
  const rawMessage =
    overrides.message ||
    data.user_message ||
    data.message ||
    (errorLike && errorLike.message) ||
    "";
  const message = String(rawMessage || "").trim() || AI_CREDIT_ALERT_MESSAGE;
  const normalizedMessage = normalizeText(message);
  const isMatched =
    code === AI_CREDIT_EXHAUSTED_CODE ||
    normalizedMessage.indexOf(normalizeText(AI_CREDIT_EXHAUSTED_MESSAGE)) !== -1 ||
    LEGACY_LIMIT_MESSAGES.some((item) => normalizedMessage.indexOf(item) !== -1);

  return {
    matched: isMatched,
    code: code || (isMatched ? AI_CREDIT_EXHAUSTED_CODE : ""),
    title: overrides.title || AI_CREDIT_EXHAUSTED_MESSAGE,
    message: message || AI_CREDIT_ALERT_MESSAGE,
    source: overrides.source || data.source || "api",
  };
}

export function dispatchAiCreditAlert(errorLike, overrides = {}) {
  const payload = getAiCreditErrorPayload(errorLike, overrides);
  if (!payload.matched || typeof window === "undefined" || typeof window.dispatchEvent !== "function") {
    return false;
  }

  window.dispatchEvent(new CustomEvent(AI_CREDIT_EVENT, { detail: payload }));
  return true;
}
